
<div class="search-rooms">
  <div class="search-input">
    <input type="text" placeholder="{{ i18n.str('challengeu.mp_rooms_find_room', 'FIND ROOM')() }}" maxlength="128" [(ngModel)]="roomInput" (ngModelChange)="searchRooms()">
    <i class="fa fa-search"></i>
  </div>
  <br><br>
  <a class="refresh-rooms-btn align-center" href="#" title="{{ i18n.str('challengeu.mp_rooms_refresh_rooms', 'REFRESH ROOMS')() }}" (click)="refreshRooms($event)">
    <i class="fa fa-sync"></i>
  </a>
</div>

@if (filteredRooms$ | async; as playRooms) {
  @if (playRooms.length > 0) {
    <ul class="rooms-list">
      @for (room of playRooms; track room) {
        <li>
          <h2>{{room.roomName}}</h2>
          <div class="room">
            <div class="avatar">
              <img [src]="'assets/app-branding/img/avatars/cartoon/' + room.host?.avatar">
            </div>
            <h3 style="justify-content: left;">{{room.host?.name}}</h3>
            <div style="padding: .5em 3em;" >
              @for (item of [].constructor(room.missingPlayers); track item) {
                <img style="width: 2em" src="assets/app-branding/img/Icons-chair.png">
              }
            </div>
            <p class="jeopardy-button primary" [class.secondary]="room.alreadyJoined" [class.disabled]="gameInProgress && gameInProgress !== room.gameId">
              @if (!room.alreadyJoined) {
                <a href="#" (click)="joinRoom($event, room)">
                  @if (room.private) {
                    <i class="fa fa-key"></i>
                  }
                  {{ i18n.str('challengeu.mp_rooms_join', "JOIN")() }}
                </a>
              }
              @if (room.alreadyJoined) {
                <a href="#" (click)="joinLobby($event, room)">{{ i18n.str('challengeu.mp_lobby', "Lobby")() }}</a>
              }
            </p>
          </div>
          <hr class="separator">
        </li>
      }
    </ul>
  } @else {
    <p style="padding: 1em">No rooms found</p>
  }
}



<br>
  <p class="jeopardy-button primary" style="margin-right: .5em;">
    <a href="#" (click)="createRoom($event)">{{ i18n.str('challengeu.mp_rooms_create', "CREATE NEW ROOM")() }}</a>
  </p>
  <p class="jeopardy-button secondary">
    <a href="#" routerLink="/main-menu">{{ i18n.str('challengeu.mp_back_main_menu', "BACK TO MAIN MENU")() }}</a>
  </p>